import CountriesCard from './CountriesCard.tsx';

export default CountriesCard;
